/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountOrderTemplatesTileViewProps } from './account-order-templates-tile';

const AccountOrderTemplatesTileView: React.FC<IAccountOrderTemplatesTileViewProps> = props => {
    const { AccountOrderTemplatesTile, heading, description, links } = props;

    return (
        <Module {...AccountOrderTemplatesTile}>
            {heading}
            {description}
            {links}
        </Module>
    );
};

export default AccountOrderTemplatesTileView;
